var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivitynodataicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.958,
    height: 63.521,
    viewBox: "0 0 62.958 63.521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(-123.042 -537.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(-900.5 38.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    d: "M1086.5,530.7a31.48,31.48,0,1,1-31.479-31.76A31.62,31.62,0,0,1,1086.5,530.7",
    transform: "translate(0 0)",
    fill: "#add095"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(1003.743 -1514.788)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    "data-name": "Path 1863",
    d: "M-760.143,2172.48c.138.039.373.1.6.172q9.558,3.181,19.115,6.367c1.3.435,1.5,1.341.522,2.328-.839.844-1.662,1.7-2.531,2.516-.413.385-.452.613-.019,1.035,2.034,1.985,4.031,4.007,6.039,6.019.873.875.867,1.4-.019,2.288q-2.171,2.176-4.347,4.346c-.855.853-1.4.858-2.24.017-2.012-2.007-4.034-4-6.019-6.038-.437-.448-.68-.412-1.083.019-.841.9-1.729,1.76-2.61,2.623a1.189,1.189,0,0,1-2.149-.483q-3.259-9.741-6.5-19.489C-761.713,2173.19-761.183,2172.416-760.143,2172.48Z",
    transform: "translate(-93.473 -93.424)",
    fill: "#fefdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    "data-name": "Path 1864",
    d: "M-760.841,2069.482c0,1.1.008,2.2,0,3.3-.008.836-.494,1.387-1.187,1.379s-1.162-.551-1.165-1.4q-.011-3.3,0-6.594c0-.857.462-1.366,1.185-1.359s1.161.517,1.168,1.379C-760.835,2067.284-760.841,2068.383-760.841,2069.482Z",
    transform: "translate(-91.977)",
    fill: "#fefdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    d: "M-864.581,2173.171c-1.077,0-2.154.006-3.231,0-.867-.006-1.378-.439-1.393-1.155-.015-.745.505-1.2,1.412-1.2q3.264-.009,6.528,0c.855,0,1.4.457,1.412,1.152.017.714-.548,1.2-1.431,1.2C-862.383,2173.177-863.482,2173.171-864.581,2173.171Z",
    transform: "translate(0 -91.979)",
    fill: "#fefdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    d: "M-830.91,2101.893a1.078,1.078,0,0,1-.645,1.064,1.16,1.16,0,0,1-1.392-.271l-3.322-3.317c-.5-.5-1.005-.99-1.493-1.5a1.183,1.183,0,0,1-.079-1.76,1.169,1.169,0,0,1,1.712.095c1.614,1.6,3.213,3.208,4.819,4.813A1.2,1.2,0,0,1-830.91,2101.893Z",
    transform: "translate(-26.906 -26.876)",
    fill: "#fefdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    d: "M-718.167,2096.918a1.341,1.341,0,0,1-.437.97c-1.591,1.589-3.176,3.183-4.773,4.765a1.189,1.189,0,0,1-1.758.087,1.2,1.2,0,0,1,.132-1.76c1.568-1.58,3.146-3.15,4.719-4.726a1.192,1.192,0,0,1,1.434-.346A1.13,1.13,0,0,1-718.167,2096.918Z",
    transform: "translate(-124.726 -26.888)",
    fill: "#fefdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    d: "M-830.93,2209.7a1.207,1.207,0,0,1-.4.877c-1.607,1.6-3.2,3.217-4.82,4.813a1.164,1.164,0,0,1-1.711.094,1.174,1.174,0,0,1,.078-1.759c1.6-1.613,3.209-3.212,4.815-4.817a1.162,1.162,0,0,1,1.392-.271A1.072,1.072,0,0,1-830.93,2209.7Z",
    transform: "translate(-26.886 -124.693)",
    fill: "#fefdfd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitynodataicon);
export default __webpack_public_path__ + "static/media/activitynodataicon.f911d4a47aea9dc34c11c60ef03fc7ab.svg";
export { ForwardRef as ReactComponent };